import React from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import ContactConversation from './ContactConversation';

export default function ModalConversations({ close, open, channel, userId }) {
  return (
    <Dialog open={open} maxWidth="md" fullWidth onClose={() => close()}>
      <DialogContent>
        <ContactConversation channel={channel} userId={userId} />
      </DialogContent>
    </Dialog>
  );
}

ModalConversations.propTypes = {};

ModalConversations.defaultProps = {};
